import "./App.css";
import store from "./store/index.js";
import { Provider, useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { HTTP_ERROR_CODES } from "./constants/error.js";
import { AuthRoute, RequireAuth, AuthGuard } from "./components";
import { ROLE_USER } from "./constants/app.js";
import * as Pages from "./pages";
import * as ROUTES from "./constants/routes";
import ApprovalSettings from "./pages/approval-settings/ApprovalSettings.js";
import { startRefreshInterval } from "./store/actions";
import React, { useEffect } from "react";

function App() {
  const dispatch = useDispatch();
  const authState = useSelector((s) => s.auth);
  useEffect(() => {
    if (authState.refresh_token) {
      dispatch(startRefreshInterval());
    }
  }, []);
  return (
    <Provider store={store}>
      <Routes>
        <Route path={ROUTES.HOME} element={<Pages.SignInPage />} />
        {/*<Route path={ROUTES.SIGN_UP} element={<Pages.SignUpPage />} />*/}
        {/*<Route*/}
        {/*  path={ROUTES.SIGN_UP_CONFIRM}*/}
        {/*  element={<Pages.SignUpConfirmPage />}*/}
        {/*/>*/}
        {/*<Route*/}
        {/*  path={ROUTES.SIGN_UP_RESULT}*/}
        {/*  element={<Pages.SignUpResultPage />}*/}
        {/*/>*/}
        <Route path={ROUTES.SIGN_IN} element={<Pages.SignInPage />} />
        <Route
          path={ROUTES.LOG_OUT}
          element={
            <AuthRoute>
              <Pages.Logout />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.DASHBOARD}
          element={
            <AuthRoute>
              <Pages.TopPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.MASTER_DASHBOARD}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.MasterTopPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.CHANGE_PASSWORD}
          element={
            <AuthRoute>
              <Pages.ChangePasswordPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.MACHINE_INPUT}
          element={
            <AuthRoute>
              <Pages.MachineInputPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.REGISTER_INSPECTION}
          element={
            <AuthRoute>
              <Pages.RegisterInspectionPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.UPDATE_INSPECTION}
          element={
            <AuthRoute>
              <Pages.UpdateInspectionPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.JUDGMENT}
          element={
            <AuthRoute>
              <Pages.Judgment />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.UNFINISHED_ACTION_LIST}
          element={
            <AuthRoute>
              <Pages.UnfinishedActionListPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.REGISTER_TREATMENT}
          element={
            <AuthRoute>
              <Pages.RegisterTreatmentPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.MY_PAGE}
          element={
            <AuthRoute>
              <Pages.MyPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.SETTING}
          element={
            <AuthGuard requiredRoles={[ROLE_USER.SUPER_ADMIN]}>
              <Pages.Settings />
            </AuthGuard>
          }
        />

        <Route
          path={ROUTES.SEARCH}
          element={
            <AuthRoute>
              <Pages.SearchPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.SEARCH_MACHINES}
          element={
            <AuthRoute>
              <Pages.SearchMachinesPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.SEARCH_TREATMENT_HISTORY_DETAIL}
          element={
            <AuthRoute>
              <Pages.SearchTreatmentHistoryDetail />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.SEARCH_INSPECTION_HISTORY_RESULT}
          element={
            <AuthRoute>
              <Pages.SearchInspectionHistoryResult />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.SEARCH_INSPECTION_HISTORY_CONFIRM}
          element={
            <AuthRoute>
              <Pages.InspectionHistoryConfirmPage />
            </AuthRoute>
          }
        />
        <Route
          path={ROUTES.SEARCH_INSPECTION_HISTORY_CORRECTION}
          element={
            <AuthRoute>
              <Pages.InspectionHistoryCorrectionPage />
            </AuthRoute>
          }
        />

        <Route
          path={ROUTES.MACHINE_MASTER_DASHBOARD}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.MachineTopPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.MACHINE_MASTER_UPDATE}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.MachineUpdatePage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.MACHINE_MASTER_HISTORY_SEARCH}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.MachineHistorySearchPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.MACHINE_MASTER_IMPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.MachineImportPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.MACHINE_MASTER_EXPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.MachineExportPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.MACHINE_MASTER_GROUP_UPDATE}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.MachineGroupUpdatePage />
            </AuthGuard>
          }
        />

        <Route
          path={ROUTES.DEPARTMENT_MASTER_DASHBOARD}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.DepartmentTopPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.DEPARTMENT_MASTER_UPDATE}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.DepartmentUpdate />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.DEPARTMENT_MASTER_HISTORY_SEARCH}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.DepartmentHistorySearchPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.DEPARTMENT_MASTER_IMPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.DepartmentImportPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.DEPARTMENT_MASTER_EXPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.DepartmentExportPage />
            </AuthGuard>
          }
        />

        <Route
          path={ROUTES.POSITION_MASTER_DASHBOARD}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.PositionTopPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.POSITION_MASTER_UPDATE}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.PositionUpdatePage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.POSITION_MASTER_HISTORY_SEARCH}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.PositionHistorySearchPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.POSITION_MASTER_IMPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.PositionImportPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.POSITION_MASTER_EXPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.PositionExportPage />
            </AuthGuard>
          }
        />

        <Route
          path={ROUTES.APPROVAL_SETTING_MASTER_DASHBOARD}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.ApprovalSettingTopPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.APPROVAL_SETTING}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <ApprovalSettings.ApprovalSettingsList />
            </AuthGuard>
          }
        />
        <Route
          path={`${ROUTES.APPROVAL_SETTING}/:workFollowId`}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <ApprovalSettings.WorkflowDetails />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.APPROVAL_SETTING_MASTER_SEARCH}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.ApprovalSettingSearchPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.APPROVAL_SETTING_MASTER_IMPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.ApprovalSettingImportPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.APPROVAL_SETTING_MASTER_EXPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.ApprovalSettingExportPage />
            </AuthGuard>
          }
        />

        <Route
          path={ROUTES.INSPECTION_TEMPLATE_MASTER_DASHBOARD}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.InspectionTemplateTopPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.TEMPLATE_MANAGEMENT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.TemplateManagement />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.EDIT_INSPECTION_ITEM}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.EditInspectionItemPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.INSPECTION_TEMPLATE_MASTER_SEARCH}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.InspectionTemplateSearchPage />
            </AuthGuard>
          }
        />
        {/*<Route*/}
        {/*  path={ROUTES.INSPECTION_TEMPLATE_MASTER_IMPORT}*/}
        {/*  element={*/}
        {/*    <AuthGuard*/}
        {/*      requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}*/}
        {/*    >*/}
        {/*      <Pages.InspectionTemplateImportPage />*/}
        {/*    </AuthGuard>*/}
        {/*  }*/}
        {/*/>*/}
        {/*<Route*/}
        {/*  path={ROUTES.INSPECTION_TEMPLATE_MASTER_EXPORT}*/}
        {/*  element={*/}
        {/*    <AuthGuard*/}
        {/*      requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}*/}
        {/*    >*/}
        {/*      <Pages.InspectionTemplateExportPage />*/}
        {/*    </AuthGuard>*/}
        {/*  }*/}
        {/*/>*/}

        <Route
          path={ROUTES.USERS_DASHBOARD}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.UserTopPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.USER_MASTER_UPDATE}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.UserUpdatePage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.USER_MASTER_HISTORY_SEARCH}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.UserHistorySearchLogPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.USER_MASTER_IMPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.UserImportPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.USER_MASTER_EXPORT}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.UserExportPage />
            </AuthGuard>
          }
        />
        <Route
          path={ROUTES.USER_MASTER_SEARCH}
          element={
            <AuthGuard
              requiredRoles={[ROLE_USER.SUPER_ADMIN, ROLE_USER.MASTER_ADMIN]}
            >
              <Pages.UserSearchPage />
            </AuthGuard>
          }
        />

        <Route
          path="*"
          element={<Pages.ErrorPage errorCode={HTTP_ERROR_CODES.NOT_FOUND} />}
        />
        <Route
          path="/error-403"
          element={<Pages.ErrorPage errorCode={HTTP_ERROR_CODES.FORBIDDEN} />}
        />
        <Route
          path="/error-500"
          element={
            <Pages.ErrorPage
              errorCode={HTTP_ERROR_CODES.INTERNAL_SERVER_ERROR}
            />
          }
        />
        <Route
          path="/error-401"
          element={
            <Pages.ErrorPage errorCode={HTTP_ERROR_CODES.UNAUTHORIZED} />
          }
        />

        <Route path="/" element={<RequireAuth />}>
          <Route
            path={ROUTES.INSPECTION_STATUS}
            element={<Pages.InspectionStatus />}
          />
          <Route
            path={ROUTES.INSPECTION_SHEET}
            element={<Pages.InspectionSheet />}
          />
        </Route>

        <Route
          path={ROUTES.FFMPEG_CORE_LIBS}
          element={<Pages.FFmpegCoreLibs />}
        />
      </Routes>
    </Provider>
  );
}

export default App;
